// extracted by mini-css-extract-plugin
module.exports = {"icon":"ExtraInfo_icon__2LeYX","tooltip":"ExtraInfo_tooltip__iS6qQ"};